import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../api';
import './KelambakkamCampus.css';

// Import Components
import DynamicBanner from '../Pages/include/DynamicBanner';
import Overview from './Partials/Overview';
import SchoolsAndColleges from './Partials/SchoolsAndColleges';
import VisionMission from './Partials/VisionMission';
import Facilities from './Partials/Facilities';
import Apply from './Partials/Apply';
import Contact from './Partials/Contact';
import NotFound from '../Pages/NotFound/NotFound';

const KelambakkamCampus = () => {
    const {campus_slug} = useParams();
    const [bannerData, setBannerData] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        const fetchBannerData = async () => {
            try {
                const response = await api.get(`api/campus/${campus_slug}`);

                if (response.data.success) {
                 setBannerData({
    banner_title: response.data.data.banner_title,
    banner_images: response.data.data.banner_images,
    mobile_banner_images: response.data.data.mobile_banner_images,
});

                } else {
                     console.error('API call failed:', response.data.message);
                     setNotFound(true);
                }

            } catch (error) {
                console.error('Error fetching campus banner data:', error);
                setNotFound(true);
            }
        };

        fetchBannerData();

        const counters = document.querySelectorAll(".counter");
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const counter = entry.target;
                    const target = parseInt(counter.textContent, 10);
                    let count = 1;
                    const speed = Math.max(5, 50 / target);
                    
                    const updateCounter = () => {
                        counter.textContent = count;
                        if (count < target) {
                            count++;
                            setTimeout(updateCounter, speed);
                        }
                    };
                    updateCounter();
                    observer.unobserve(counter);
                }
            });
        }, { threshold: 0.5 });
        
        counters.forEach(counter => observer.observe(counter));

        return () => observer.disconnect();
    }, []);

    if (notFound) return <NotFound />;

    return (
        <div className="kelambakkam-campus">
            {bannerData && (
                <DynamicBanner 
                title={bannerData.banner_title} 
                bgImage={bannerData.banner_images} 
                bgImageMobile={bannerData.mobile_banner_images}
                />
            )}
            <Overview />
            <SchoolsAndColleges />
            <VisionMission />
            <Facilities />
            <Apply />
            <Contact />
        </div>
    );
};

export default KelambakkamCampus;